// Utility to dynamically load Google AdSense script
let adsenseLoaded = false;
let adsenseLoading = false;

export const loadAdSenseScript = () =>
{
  // Don't load if ads are disabled
  if( process.env.REACT_APP_DISABLE_AD_BANNERS )
  {
    return Promise.resolve();
  }

  // Don't load if already loaded or loading
  if( adsenseLoaded || adsenseLoading )
  {
    return Promise.resolve();
  }

  adsenseLoading = true;

  return new Promise( ( resolve, reject ) =>
  {
    const script = document.createElement( 'script' );
    script.async = true;
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9609772701049084';
    script.crossOrigin = 'anonymous';

    script.onload = () =>
    {
      adsenseLoaded = true;
      adsenseLoading = false;
      console.log( 'Google AdSense script loaded successfully' );
      resolve();
    };

    script.onerror = () =>
    {
      adsenseLoading = false;
      console.warn( 'Failed to load Google AdSense script' );
      reject( new Error( 'Failed to load AdSense script' ) );
    };

    document.head.appendChild( script );
  } );
};

export const isAdSenseLoaded = () => adsenseLoaded;
export const isAdSenseEnabled = () => !process.env.REACT_APP_DISABLE_AD_BANNERS;
